export const navLinks = [
  { label: '首页', href: '#hero' },
  { label: '热度排行', href: '#ranking' },
  { label: '平台特色', href: '#features' },
  { label: '精选专题', href: '#carousel' },
  { label: '关于我们', href: '#about' },
  { label: '精彩推荐', href: '#media' },
  { label: '最新动态', href: '#updates' },
];

export const heroData = {
  tagline: '魔法世界 · 奇幻冒险 · 异能觉醒',
  title: '非麻瓜漫画',
  subtitle: '魔法奇幻异能漫画免费阅读平台',
  description1: '非麻瓜漫画是一个专为魔法漫画爱好者打造的在线阅读平台，汇聚了全网最优质的魔法漫画、奇幻漫画与异能漫画资源。无论你是哈利波特式的魔法迷，还是热爱东方玄幻的仙侠读者，这里都有属于你的那片魔法世界。',
  description2: '平台每日更新热门连载，采用下拉式一看到底的阅读模式，让你告别翻页打断，沉浸在魔法漫画的连续剧情中。所有漫画均为免费阅读，无需注册即可畅享完整篇章。',
  stats: [
    { value: '12,000+', label: '魔法奇幻漫画' },
    { value: '每日更新', label: '热门连载不断' },
    { value: '完全免费', label: '无需注册阅读' },
  ],
  primaryCta: { label: '开始阅读', href: '#index' },
  secondaryCta: { label: '了解平台', href: '#about' },
};

export const aboutData = {
  title: '关于非麻瓜漫画',
  content: '非麻瓜漫画诞生于对魔法世界的无限热爱。我们相信每个人心中都藏着一个魔法师，只是还未找到属于自己的魔杖。平台从全球范围内精心挑选魔法漫画、奇幻漫画与异能漫画，覆盖日漫、韩漫、国漫等多种风格，致力于为读者打造一个纯粹而丰富的魔法漫画阅读空间。我们坚持免费阅读原则，让每一个热爱奇幻漫画的灵魂都能无障碍地进入魔法世界。',
  highlights: ['精选优质魔法奇幻漫画', '每日更新热门连载', '下拉式沉浸阅读', '完全免费无需注册'],
};

export const commentsData = [
  {
    id: 1,
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20young%20woman%20portrait%20in%20warm%20lighting%2C%20soft%20natural%20look%2C%20simple%20cream%20background%2C%20editorial%20style%2C%20gentle%20expression&width=80&height=80&seq=avatar-comic-01&orientation=squarish',
    name: '魔法学徒小月',
    comment: '非麻瓜漫画真的是魔法漫画爱好者的宝藏站！下拉式阅读体验太棒了，一口气追完好几部奇幻漫画，完全停不下来。',
    date: '2026-07-25',
    likes: 328,
  },
  {
    id: 2,
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20man%20portrait%20with%20casual%20style%2C%20friendly%20smile%2C%20soft%20lighting%2C%20simple%20cream%20background%2C%20editorial%20photography&width=80&height=80&seq=avatar-comic-02&orientation=squarish',
    name: '异能使者阿凯',
    comment: '异能漫画的分类特别全，很多冷门但超好看的异能漫画都能在这里找到。每天刷更新已经成了我的日常习惯！',
    date: '2026-07-23',
    likes: 256,
  },
  {
    id: 3,
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20girl%20with%20glasses%20portrait%2C%20intelligent%20look%2C%20warm%20indoor%20lighting%2C%20simple%20cream%20background%2C%20editorial%20style%2C%20gentle%20smile&width=80&height=80&seq=avatar-comic-03&orientation=squarish',
    name: '书虫小琳',
    comment: '奇幻漫画大全真的太全了，从经典到最新连载应有尽有。页面干净没有广告干扰，阅读体验比很多付费站都好！',
    date: '2026-07-20',
    likes: 412,
  },
  {
    id: 4,
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20teenager%20boy%20portrait%2C%20energetic%20expression%2C%20soft%20warm%20lighting%2C%20simple%20cream%20background%2C%20editorial%20photography%2C%20natural%20look&width=80&height=80&seq=avatar-comic-04&orientation=squarish',
    name: '火焰少年小杰',
    comment: '魔法世界漫画这个分类简直为我量身定做！里面的漫画画风精美、剧情在线，每一部都是精品。强烈推荐给所有魔法漫画迷！',
    date: '2026-07-18',
    likes: 189,
  },
  {
    id: 5,
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20young%20woman%20portrait%20with%20long%20hair%2C%20elegant%20style%2C%20warm%20soft%20lighting%2C%20simple%20cream%20background%2C%20editorial%20photography%2C%20gentle%20smile&width=80&height=80&seq=avatar-comic-05&orientation=squarish',
    name: '夜读少女安安',
    comment: '朋友推荐的非麻瓜漫画，一开始只是试试看，结果彻底入坑了。魔法漫画加上奇幻漫画的资源真的又多又精，现在每天睡前必刷！',
    date: '2026-07-15',
    likes: 503,
  },
];

export const mediaData = [
  {
    id: 1,
    title: '魔法漫画精选推荐 · 2026夏季新番',
    thumbnail: 'https://readdy.ai/api/search-image?query=Magical%20comic%20book%20pages%20with%20floating%20spell%20effects%20and%20golden%20magical%20particles%2C%20warm%20amber%20and%20cream%20color%20palette%2C%20mystical%20atmosphere%2C%20open%20ancient%20book%20with%20glowing%20runes%2C%20soft%20ethereal%20lighting%2C%20fantasy%20editorial%20style&width=640&height=360&seq=media-comic-01&orientation=landscape',
    tag: '新番推荐',
    views: '12.8万',
  },
  {
    id: 2,
    title: '异能漫画人气排行 · 燃向战斗混剪',
    thumbnail: 'https://readdy.ai/api/search-image?query=Dynamic%20superpower%20battle%20scene%20in%20comic%20style%2C%20energy%20bursts%20and%20lightning%20effects%2C%20dramatic%20composition%2C%20warm%20crimson%20and%20amber%20tones%2C%20action%20manga%20aesthetic%2C%20intense%20atmosphere%20with%20glowing%20elements&width=640&height=360&seq=media-comic-02&orientation=landscape',
    tag: '人气排行',
    views: '9.6万',
  },
  {
    id: 3,
    title: '奇幻漫画大全 · 东方玄幻专题',
    thumbnail: 'https://readdy.ai/api/search-image?query=Eastern%20fantasy%20landscape%20with%20floating%20mountains%20and%20ancient%20temples%2C%20mystical%20mist%20and%20golden%20clouds%2C%20ink%20wash%20painting%20style%20blended%20with%20comic%20aesthetic%2C%20warm%20earthy%20tones%2C%20ethereal%20atmosphere%2C%20traditional%20Chinese%20fantasy%20vibe&width=640&height=360&seq=media-comic-03&orientation=landscape',
    tag: '东方玄幻',
    views: '8.3万',
  },
];

export const indexData = [
  { id: 1, title: '魔法学院', icon: 'ri-magic-line', count: '2,380部', desc: '霍格沃茨式的魔法校园故事' },
  { id: 2, title: '异界转生', icon: 'ri-loop-left-line', count: '1,950部', desc: '穿越异世界的奇幻冒险' },
  { id: 3, title: '超能力者', icon: 'ri-flashlight-line', count: '3,120部', desc: '异能觉醒的燃向战斗' },
  { id: 4, title: '剑与魔法', icon: 'ri-sword-line', count: '2,760部', desc: '西方奇幻的史诗征程' },
  { id: 5, title: '东方玄幻', icon: 'ri-ancient-gate-line', count: '4,500部', desc: '仙侠修真的东方幻想' },
  { id: 6, title: '暗黑奇幻', icon: 'ri-moon-clear-line', count: '1,680部', desc: '黑暗风格的诡谲魔法世界' },
  { id: 7, title: '少女魔法', icon: 'ri-heart-line', count: '2,150部', desc: '魔法与恋爱的甜蜜交织' },
  { id: 8, title: '冒险游记', icon: 'ri-compass-3-line', count: '3,400部', desc: '奇幻世界的探索之旅' },
  { id: 9, title: '神魔大战', icon: 'ri-shield-flash-line', count: '1,890部', desc: '神魔对决的宏大战场' },
];

export const faqData = [
  {
    id: 1,
    question: '非麻瓜漫画上的所有漫画真的都是免费的吗？',
    answer: '是的！非麻瓜漫画承诺所有魔法漫画、奇幻漫画与异能漫画均为免费阅读。我们通过广告合作维持运营，不会向读者收取任何费用，也无需注册会员即可畅读所有漫画全集。',
  },
  {
    id: 2,
    question: '下拉式阅读是什么意思？如何操作？',
    answer: '下拉式漫画阅读是一种流畅的浏览方式，你只需向下滚动页面，漫画章节会自动连续加载，无需点击翻页按钮。这种设计让你可以一口气读完整个章节，获得沉浸式的魔法漫画阅读体验。',
  },
  {
    id: 3,
    question: '平台上的漫画多久更新一次？',
    answer: '热门连载漫画通常保持每日更新，部分作品根据原作者发布节奏可能为每周更新。你可以在"最新动态"板块实时查看所有魔法世界漫画的更新状态，第一时间追更你喜爱的作品。',
  },
  {
    id: 4,
    question: '如何找到特定类型的魔法或奇幻漫画？',
    answer: '你可以通过首页的"主题索引"板块浏览九大分类专题，也可以通过"话题标签"区域找到热门标签。如果你有特定的漫画想找，欢迎通过"联系我们"板块向我们推荐或咨询。',
  },
];

export const updatesData = [
  { id: 1, date: '07-29', title: '《星尘魔导书》第108话更新', type: '更新', tag: '魔法漫画' },
  { id: 2, date: '07-29', title: '《异能觉醒者》第76话更新', type: '更新', tag: '异能漫画' },
  { id: 3, date: '07-28', title: '《九幽玄界》第52话更新', type: '更新', tag: '奇幻漫画' },
  { id: 4, date: '07-28', title: '夏日魔法季专题上线', type: '专题', tag: '魔法世界' },
  { id: 5, date: '07-27', title: '《暗黑魔法学院》第33话更新', type: '更新', tag: '魔法漫画' },
  { id: 6, date: '07-27', title: '《元素掌控者》第89话更新', type: '更新', tag: '异能漫画' },
  { id: 7, date: '07-26', title: '《龙骑士传说》第120话更新', type: '更新', tag: '奇幻漫画' },
  { id: 8, date: '07-26', title: '2026夏季新番推荐榜单发布', type: '榜单', tag: '漫画大全' },
  { id: 9, date: '07-25', title: '《魔法工坊》番外篇上线', type: '番外', tag: '魔法漫画' },
];

export const topicsData = [
  { id: 1, name: '魔法学院', heat: '9.8', color: 'primary' },
  { id: 2, name: '转生异界', heat: '9.5', color: 'accent' },
  { id: 3, name: '超能力', heat: '9.3', color: 'secondary' },
  { id: 4, name: '东方玄幻', heat: '9.7', color: 'primary' },
  { id: 5, name: '剑与魔法', heat: '9.1', color: 'accent' },
  { id: 6, name: '暗黑奇幻', heat: '8.9', color: 'secondary' },
  { id: 7, name: '少女恋爱', heat: '8.7', color: 'primary' },
  { id: 8, name: '神魔大战', heat: '8.5', color: 'accent' },
  { id: 9, name: '冒险游记', heat: '8.3', color: 'secondary' },
  { id: 10, name: '魔法道具', heat: '8.1', color: 'primary' },
  { id: 11, name: '异能觉醒', heat: '9.0', color: 'accent' },
];

export const contactData = {
  title: '联系我们',
  description: '无论你是想推荐好看的魔法漫画、奇幻漫画，还是有合作投稿意向，都欢迎通过以下方式联系非麻瓜漫画团队。我们珍视每一位魔法世界漫画爱好者的声音！',
  email: 'contact@feimagua.com',
  wechat: 'feimagua_official',
  qq: '800123456',
};

export const featuresData = [
  {
    id: 1,
    icon: 'ri-book-open-line',
    title: '海量漫画资源',
    desc: '收录超过12,000部魔法漫画、奇幻漫画与异能漫画，涵盖日漫、韩漫、国漫等多种风格，满足不同读者的口味偏好。',
  },
  {
    id: 2,
    icon: 'ri-arrow-down-line',
    title: '下拉式沉浸阅读',
    desc: '独创下拉式漫画阅读模式，告别翻页打断。魔法世界漫画章节自动连续加载，让你沉浸在魔法故事中一看到底。',
  },
  {
    id: 3,
    icon: 'ri-shield-check-line',
    title: '完全免费无广告干扰',
    desc: '所有漫画全集免费阅读，无需注册登录。无弹窗广告、无强制跳转，为魔法漫画爱好者创造纯净的阅读环境。',
  },
  {
    id: 4,
    icon: 'ri-refresh-line',
    title: '每日同步更新',
    desc: '热门连载漫画保持每日更新节奏，第一时间同步最新章节。通过动态时间线实时掌握奇幻漫画更新状态。',
  },
  {
    id: 5,
    icon: 'ri-smartphone-line',
    title: '全平台畅读体验',
    desc: '完美适配手机、平板和电脑端，随时随地打开浏览器即可阅读魔法漫画。响应式设计确保各种屏幕尺寸下的最佳体验。',
  },
];

export const appData = {
  title: '随时随地看魔法漫画',
  description: '非麻瓜漫画完美适配手机端，无需下载App，在浏览器中即可享受流畅的下拉式漫画阅读体验。添加到手机主屏幕，像使用原生App一样方便。',
  features: ['手机浏览器即开即看', '添加到主屏幕一键直达', '下拉式阅读适配触屏', '省流量模式自动优化'],
};

export const rankingData = [
  { id: 1, rank: 1, title: '星尘魔导书', type: '魔法漫画', heat: '9.9', trend: 'up', desc: '少年获得远古魔导书，开启波澜壮阔的魔法之旅' },
  { id: 2, rank: 2, title: '异能觉醒者', type: '异能漫画', heat: '9.8', trend: 'up', desc: '末世降临，异能觉醒者们的生存之战' },
  { id: 3, rank: 3, title: '九幽玄界', type: '奇幻漫画', heat: '9.7', trend: 'stable', desc: '穿越九幽世界，修仙问道的东方奇幻史诗' },
  { id: 4, rank: 4, title: '龙骑士传说', type: '奇幻漫画', heat: '9.6', trend: 'down', desc: '龙族与人类骑士的羁绊，翱翔于魔法大陆上空' },
  { id: 5, rank: 5, title: '暗黑魔法学院', type: '魔法漫画', heat: '9.5', trend: 'up', desc: '在禁忌魔法学院中揭开尘封千年的黑暗秘密' },
  { id: 6, rank: 6, title: '元素掌控者', type: '异能漫画', heat: '9.4', trend: 'stable', desc: '风火水土四大元素使者的命运交织' },
  { id: 7, rank: 7, title: '魔法工坊', type: '魔法漫画', heat: '9.3', trend: 'up', desc: '在魔法工坊中打造传说级神器，成为传奇工匠' },
];

export const cardsData = [
  {
    id: 1,
    image: 'https://readdy.ai/api/search-image?query=Magical%20academy%20library%20with%20floating%20books%20and%20golden%20spell%20particles%2C%20warm%20amber%20lighting%2C%20ancient%20wooden%20bookshelves%2C%20mystical%20atmosphere%2C%20fantasy%20illustration%20style%2C%20soft%20glow%20effects%2C%20cream%20and%20gold%20color%20palette&width=600&height=400&seq=card-comic-01&orientation=landscape',
    title: '魔法学院题材精选',
    desc: '从霍格沃茨到东方魔法学府，最全魔法学院漫画合集',
    tag: '魔法乐园',
  },
  {
    id: 2,
    image: 'https://readdy.ai/api/search-image?query=Epic%20fantasy%20battle%20scene%20with%20dragons%20and%20knights%2C%20medieval%20castle%20in%20background%2C%20golden%20sunset%20lighting%2C%20heroic%20composition%2C%20fantasy%20illustration%20style%2C%20warm%20amber%20and%20crimson%20tones&width=600&height=400&seq=card-comic-02&orientation=landscape',
    title: '剑与魔法史诗之旅',
    desc: '西方奇幻经典题材，龙与骑士的壮丽冒险',
    tag: '奇幻史诗',
  },
  {
    id: 3,
    image: 'https://readdy.ai/api/search-image?query=Eastern%20fantasy%20palace%20on%20floating%20mountain%2C%20traditional%20Chinese%20architecture%2C%20golden%20clouds%20and%20mist%2C%20immortal%20cultivation%20theme%2C%20ink%20wash%20and%20gold%20color%20palette%2C%20mystical%20ethereal%20atmosphere&width=600&height=400&seq=card-comic-03&orientation=landscape',
    title: '东方玄幻修仙宇宙',
    desc: '仙侠修真、九界飞升，东方奇幻漫画大全',
    tag: '东方玄界',
  },
  {
    id: 4,
    image: 'https://readdy.ai/api/search-image?query=Superpower%20awakening%20scene%20with%20energy%20bursts%20and%20lightning%20effects%2C%20urban%20environment%2C%20dramatic%20composition%2C%20dynamic%20manga%20style%2C%20warm%20crimson%20and%20amber%20lighting%2C%20intense%20atmosphere&width=600&height=400&seq=card-comic-04&orientation=landscape',
    title: '异能觉醒燃向合集',
    desc: '超能力战斗、异能觉醒，燃到停不下来',
    tag: '异能战场',
  },
  {
    id: 5,
    image: 'https://readdy.ai/api/search-image?query=Dark%20fantasy%20forest%20with%20glowing%20crystals%20and%20ancient%20ruins%2C%20mysterious%20atmosphere%2C%20moonlight%20through%20trees%2C%20magical%20creatures%20silhouettes%2C%20warm%20amber%20and%20deep%20crimson%20tones%2C%20fantasy%20illustration&width=600&height=400&seq=card-comic-05&orientation=landscape',
    title: '暗黑奇幻诡谲世界',
    desc: '暗黑风格魔法漫画，神秘诡谲的另类魅力',
    tag: '暗黑奇谭',
  },
];

export const carouselData = [
  {
    id: 1,
    image: 'https://readdy.ai/api/search-image?query=Magical%20girl%20casting%20spells%20in%20ancient%20library%2C%20golden%20butterfly%20magic%20effects%2C%20warm%20amber%20lighting%2C%20fantasy%20anime%20art%20style%2C%20detailed%20background%20with%20floating%20books%2C%20cream%20and%20gold%20color%20palette&width=800&height=500&seq=carousel-comic-01&orientation=landscape',
    title: '星尘魔导书',
    subtitle: '魔法漫画人气榜首',
    desc: '平凡少年偶然获得远古魔导书的认可，命运的齿轮从此转动。在魔法学院中结识挚友，对抗黑暗势力，揭开尘封千年的魔法世界秘密——年度最燃魔法漫画！',
    tag: '连载中 · 108话',
  },
  {
    id: 2,
    image: 'https://readdy.ai/api/search-image?query=Epic%20dragon%20rider%20soaring%20through%20golden%20clouds%2C%20medieval%20fantasy%20landscape%20below%2C%20heroic%20composition%2C%20warm%20sunset%20lighting%2C%20fantasy%20anime%20art%20style%2C%20dramatic%20atmosphere%2C%20amber%20and%20crimson%20tones&width=800&height=500&seq=carousel-comic-02&orientation=landscape',
    title: '龙骑士传说',
    subtitle: '奇幻漫画经典之作',
    desc: '在龙族与人类共存的大陆上，少年龙骑士与他的伙伴龙踏上寻找失落龙族的冒险。宏大的世界观、细腻的情感刻画，奇幻漫画爱好者不可错过的史诗级作品。',
    tag: '连载中 · 120话',
  },
  {
    id: 3,
    image: 'https://readdy.ai/api/search-image?query=Superpower%20hero%20with%20electric%20energy%20surrounding%20body%2C%20urban%20cityscape%20at%20night%2C%20dynamic%20action%20pose%2C%20intense%20lighting%20effects%2C%20anime%20art%20style%2C%20warm%20crimson%20and%20amber%20glow%2C%20dramatic%20composition&width=800&height=500&seq=carousel-comic-03&orientation=landscape',
    title: '异能觉醒者',
    subtitle: '异能漫画燃向巅峰',
    desc: '末世降临，普通人中开始出现异能觉醒者。少年阿杰在生死边缘觉醒了雷电异能，从此踏上了守护人类最后堡垒的战斗之路。拳拳到肉的异能对决，燃爆每一页！',
    tag: '连载中 · 76话',
  },
  {
    id: 4,
    image: 'https://readdy.ai/api/search-image?query=Eastern%20fantasy%20immortal%20cultivating%20on%20mountain%20peak%2C%20nine%20golden%20dragons%20in%20sky%2C%20traditional%20Chinese%20ink%20wash%20style%20blended%20with%20anime%2C%20ethereal%20mist%20and%20golden%20light%2C%20mystical%20atmosphere&width=800&height=500&seq=carousel-comic-04&orientation=landscape',
    title: '九幽玄界',
    subtitle: '东方奇幻国漫之光',
    desc: '现代青年意外穿越至九幽玄界，在弱肉强食的修仙世界中步步为营。从凡人到天尊的逆袭之路，融合东方玄幻与精美国漫画风，一部让人欲罢不能的奇幻漫画佳作。',
    tag: '连载中 · 52话',
  },
  {
    id: 5,
    image: 'https://readdy.ai/api/search-image?query=Dark%20magic%20academy%20hallway%20with%20candlelight%20and%20ancient%20symbols%2C%20mysterious%20atmosphere%2C%20gothic%20architecture%2C%20young%20mage%20with%20glowing%20staff%2C%20fantasy%20anime%20art%20style%2C%20deep%20crimson%20and%20amber%20tones&width=800&height=500&seq=carousel-comic-05&orientation=landscape',
    title: '暗黑魔法学院',
    subtitle: '魔法世界暗黑新星',
    desc: '被诅咒的魔法学院隐藏着不可告人的秘密。新生入学后发现学院地下埋藏着禁忌魔法的源头，揭开真相的过程中，友谊与背叛交织——暗黑风格的魔法漫画，颠覆你的想象。',
    tag: '连载中 · 33话',
  },
  {
    id: 6,
    image: 'https://readdy.ai/api/search-image?query=Magical%20artisan%20workshop%20with%20glowing%20weapons%20and%20artifacts%2C%20steampunk%20fantasy%20aesthetic%2C%20warm%20forge%20lighting%2C%20detailed%20craftsman%20scene%2C%20anime%20art%20style%2C%20amber%20and%20gold%20color%20palette%2C%20cozy%20magical%20atmosphere&width=800&height=500&seq=carousel-comic-06&orientation=landscape',
    title: '魔法工坊',
    subtitle: '治愈系魔法漫画新选',
    desc: '不擅长战斗的少年在魔法工坊中找到了自己的天赋——打造魔法神器。温暖治愈的成长故事，每一件神器背后都有一个动人的故事。轻松愉快的魔法世界漫画，解压必看。',
    tag: '连载中 · 番外篇',
  },
];

export const footerData = {
  description: '非麻瓜漫画——为每一个热爱魔法世界的灵魂打造的漫画阅读平台。汇聚全网最优质的魔法漫画、奇幻漫画与异能漫画，免费下拉式阅读，畅游漫画大全的奇幻海洋。',
  quickLinks: [
    { label: '热度排行', href: '#ranking' },
    { label: '平台特色', href: '#features' },
    { label: '主题索引', href: '#index' },
    { label: '常见问答', href: '#faq' },
    { label: '关于我们', href: '#about' },
    { label: '联系我们', href: '#contact' },
  ],
  copyright: '© 2026 非麻瓜漫画 · 魔法漫画与奇幻漫画大全 · 所有漫画版权归原作者所有',
};